import {get, getLocalStorageJsonItem, merge} from "@/helpers";
import {AbstractService} from "@/services/AbstractService";
import {app} from "@/app";

export class Configuration extends AbstractService {

  sandboxed: null|boolean = null;
  appKey = 'ampx';
  appConfigKey = 'ampxConfig';

  options = {
    debug: {
      enabled: false,
      messagePrefix: 'Algoma:',
    },
    shopify: {
      attributionsUpdate: {
        enabled: process.env.PIXEL_ENABLED_SHOPIFY_ATTRIBUTIONS_UPDATE,
        cartAttributeKey: '_ampx'
      },
      observer: {
        httpRequest: {
          enabled: true,
        }
      }
    },
    localStorage: {
      config: {
        key: 'ampxConfig',
      },
      visitorId: {
        key: 'ampxVisitorId',
      },
      mutedState: {
        key: 'ampxMutedAt',
      },
      eventsStack: {
        key: 'ampxEvents',
      }
    },

    endpoint: process.env.PIXEL_ENDPOINT ?? 'https://localhost:5000/pxl',

    pixelId: null,
    shopDomain: null,
    queryParams: null,

    events: {}
  };

  /**
   * window.sizingAppConfig can be present on page where we are embedding the app
   * if it is - merge it into our options
   */
  async init() {

    // sandboxed state
    this.initSandboxedState();

    // client config options
    const appConfigKey = this.appConfigKey;
    const clientConfig = (appConfigKey in window) ? window[appConfigKey] : null;
    if (clientConfig) {
      merge(this.options, clientConfig);
      app.debug('Configuration: merged client config', clientConfig);
    }

    // local storage config options
    if(!this.sandboxed) {
      const storedConfig = getLocalStorageJsonItem(this.option('localStorage.config.key'));
      if(storedConfig) {
        merge(this.options, storedConfig);
        app.debug('Configuration: merged local storage config', storedConfig);
      }
    }
  }

  initSandboxedState() {
    if(this.sandboxed !== null) return;

    try {
      window.localStorage.debug && window.document.cookie;
      this.sandboxed = false;
    } catch (error) {
      this.sandboxed = true;
      app.debug('Configuration: app is sandboxed');
    }
  }

  option(path: string, defaultValue: any = null) {
    return get(this.options, path, defaultValue);
  }

  getEvent(eventName) {
    return get(this.options, `events.${eventName}`);
  }
}
